'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Tooltip = require('components/Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ProjectIrefImage = require('components/ProjectIrefImage/ProjectIrefImage');

var _ProjectIrefImage2 = _interopRequireDefault(_ProjectIrefImage);

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectIrefTooltip = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectIrefTooltip, _PureComponent);

  function ProjectIrefTooltip() {
    (0, _classCallCheck3.default)(this, ProjectIrefTooltip);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectIrefTooltip.__proto__ || (0, _getPrototypeOf2.default)(ProjectIrefTooltip)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectIrefTooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          iRef = _props.iRef;


      if (!iRef) {
        return null;
      }

      return _react2.default.createElement(
        _Tooltip2.default,
        {
          placement: 'top',
          title: iRef,
          onClick: _utils.stopEvent
        },
        _react2.default.createElement(_ProjectIrefImage2.default, { className: (0, _bind2.default)(className) })
      );
    }
  }]);
  return ProjectIrefTooltip;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  iRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _temp);
exports.default = ProjectIrefTooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectIrefTooltip/ProjectIrefTooltip.js
// module id = 833
// module chunks = 1